import React from 'react';
import { CountdownTimer } from './Countdown';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL } from '../utils/constants';
export function FinalCta() {
  return <section aria-labelledby="final-cta-title" className="w-full bg-brand px-4 py-8" data-id="element-85" data-mp="19g0d3ipnhwkf">
      <div className="mx-auto max-w-xl text-center" data-id="element-86" data-mp="15d42ae6cr4r1">
        <span className="inline-block rounded-full bg-mustard px-2.5 py-0.5 font-head text-[10px] font-bold uppercase tracking-wide text-night" data-id="element-87" data-mp="15fgjgp4adb31">
          Limited-Time Offer
        </span>
        <h2 id="final-cta-title" className="mt-1 font-head text-xl font-bold uppercase leading-[0.98] text-white sm:text-3xl" data-id="element-88" data-mp="1eds5sey4dmpo">
          Complete your professional teaching system today
        </h2>

        <CountdownTimer className="mt-2" data-id="element-89" data-mp="1o4n1sb1640ob" />

        <div className="mt-3 rounded-2xl bg-cream p-4" data-id="element-90" data-mp="22339a46utv7i">
          <h3 className="font-head text-lg font-bold uppercase leading-none text-night sm:text-2xl" data-id="element-91" data-mp="223wbcruvbwjb">
            Spanish Teacher Pro™
          </h3>
          <p className="text-[10px] font-semibold uppercase tracking-wide text-night/55" data-id="element-92" data-mp="n64elx7608q5">
            Professional 6-in-1 System + 5 Strategic Bonuses
          </p>
          <p className="mt-1.5 text-[12px] text-night/60" data-id="element-93" data-mp="s6ijx7hdt4kh">
            Regular Price: <span className="line-through" data-id="element-94" data-mp="x2h2ufjxxudi">$97</span>
          </p>
          <p className="font-head text-3xl font-bold leading-none text-brand sm:text-5xl" data-id="element-95" data-mp="12351nneevfia">
            TODAY: $27
          </p>
          <span className="mt-1 inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[10px] font-bold uppercase tracking-wide text-white" data-id="element-96" data-mp="163xcum6ufuh7">
            Save $70
          </span>

          <div className="mt-2.5 flex flex-col items-center" data-id="element-97" data-mp="1fvkyu7kmsjba">
            <CtaButton href={CHECKOUT_URL} data-id="element-98" data-mp="1ktw9gkir2xuk" />
            <TrustRow className="mt-1.5" accessLabel="Instant Digital Access" tone="light" data-id="element-99" data-mp="1kstm2mkmzdje" />
          </div>
        </div>
      </div>
    </section>;
}